import React, { useEffect, useState } from "react";
import Pagination from "../../../components/common/Pagination";
import DeleteModal from "../../../components/common/DeleteModal";
// import { useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { message } from "../../../redux/actions/toastActions";
import Page from "../../../helpers/config";
import HttpService from "../../../helpers/httpServices";
import { Postdata } from "../../../helpers/api.service";
import Loader from "../../../components/common/Loader";
import Title from "../../../components/common/Title";
import { Topbar } from "../../../components/include/Topbar";
import { useCountryNavigate } from "../../../components/common/UseCountryNavigate";

const AdminList = () => {
  const [data, setData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loader, setLoader] = useState(false);
  // const navigate = useNavigate()
  const navigate = useCountryNavigate();
  // const dispatch = useDispatch();
  // const location = useLocation();
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setperPage] = useState(Page.records);
  const [currentPage, setcurrentPage] = useState(1);

  const fetchData = (currentPage, perPage) => {
    setLoader(true);
    Postdata(HttpService.school_subadmin_list, {
      page: currentPage,
      perpage: perPage,
    }).then((res) => {
      if (res.status === 200) {
        setData(res.data.subadmin);
        setTotalRows(res.data.count);
      }
      //  else {
      //   dispatch(message(res.message));
      // }
      setLoader(false);
    });
  };

  const handleDelete = (id) => {
    setLoader(true);
    Postdata(HttpService.school_subadmin_delete, { id: id }).then((res) => {
      if (res.status === 200) {
        setRefresh(!refresh);
      }
      // dispatch(message(res.message));
      setLoader(false);
    });
  };

  const handlePageChange = (page) => {
    setcurrentPage(page);
    fetchData(page, perPage);
  };

  const handleRowsPerPageChange = (rows) => {
    setperPage(rows);
    setcurrentPage(1);
    fetchData(1, rows);
  };

  useEffect(() => {
    fetchData();
  }, [refresh]);

  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }
  return (
    <>
      <Title name="Admin Management" />
      <Topbar title="Admin Management" />
      <div className="p-6 space-y-6 pr-0">
        <div className="flex justify-end">
          <button
            className={`button-small-primary`}
            onClick={() => navigate(`admin-subadmin/add`)}
          >
            + Add Admins
          </button>
        </div>
        <div className="bg-white rounded  overflow-x-auto">
          <table className="min-w-full text-sm text-left">
            <thead className=" text-gray-700">
              <tr>
                <th className="px-6 py-3 font-medium">Name</th>
                <th className="px-6 py-3 font-medium">Email</th>
                <th className="px-6 py-3 font-medium">Role</th>
                <th className="px-6 py-3 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{item.username}</td>
                  <td className="px-6 py-4">{item.email}</td>
                  <td className="px-6 py-4">{item.role}</td>
                  <td className="px-6 py-4 space-x-3">
                    <button
                      className="text-primary_main hover:underline"
                      onClick={() =>
                        navigate(`admin-subadmin/edit/${item._id}`, {
                          state: {
                            type: "edit",
                          },
                        })
                      }
                    >
                      Edit
                    </button>
                    <button
                      className="text-red-600 hover:underline"
                      onClick={() => {
                        // add your delete handler here
                        setSelectedId(item._id);
                        setmodalOpenDelete(true);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {data.length === 0 && (
          <div className="h-[50vh] flex items-center justify-center w-full">
            <h1 className="text-center text-gray-400">No Data Found</h1>
          </div>
        )}
        <Pagination
          currentPage={currentPage}
          totalRows={totalRows}
          perPage={perPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          type="Admin Management"
        />
        <DeleteModal
          title="Delete Admin"
          message="Are you sure you want to delete Admin?
        It will erase all the data permanently."
          modalOpenDelete={modalOpenDelete}
          setmodalOpenDelete={setmodalOpenDelete}
          handleDelete={handleDelete} // Don't call it here
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          modalOpenDeleteSuccess={modalOpenDeleteSuccess}
          setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
          module={"Admin "}
          redirectPage={"Admin Management"}
          redirectUrl={"subadmin"}
        />
      </div>
    </>
  );
};

export default AdminList;
